module.exports = __webpack_public_path__ + "img/nongye.6d4114cf.png";